// extracted by mini-css-extract-plugin
export var center = "section-module--center--53c0f";
export var content = "section-module--content--30873";
export var footer = "section-module--footer--d512b";
export var l = "section-module--l--75e4f";
export var left = "section-module--left--fdf77";
export var m = "section-module--m--06655";
export var mb = "section-module--mb--9c81f";
export var mt = "section-module--mt--f6eb6";
export var mtb = "section-module--mtb--9f091";
export var responsive = "section-module--responsive--66c19";
export var right = "section-module--right--deef6";
export var s = "section-module--s--3483a";
export var section = "section-module--section--0c038";
export var widthM = "section-module--widthM--86f9e";
export var widthS = "section-module--widthS--082fd";
export var x_m = "section-module--x_m--035e6";
export var x_s = "section-module--x_s--3c943";
export var x_xl = "section-module--x_xl--36765";